const marketCapSourceEnum = Object.freeze({
    COMPANY: 'COMPANY',
    CALCULATED: 'CALCULATED',
    MORNINGSTAR: 'MORNINGSTAR'
});

export default marketCapSourceEnum;
